export { elementContains } from '@fluentui/dom-utilities';
//# sourceMappingURL=elementContains.js.map